/**
 * SC Visualisation Reducers
 */
import {
   SCVISUAL_ACTION, 
   FETCH_SCYEAR,
   SC_VISUALISATION_DETAILS,
   ALL_SCVISUAL,
   SC_CREATE_VISUALISATION,
   SC_VISUALISATION_DELETE
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    scvisualisationlist:[],
    scvisualisationdetails:[],
    scyears:[],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case SCVISUAL_ACTION:
            return { ...state, loading: true };
        
        case ALL_SCVISUAL:
            return { ...state, loading: false, scvisualisationlist: action.payload };

        case FETCH_SCYEAR:
            return { ...state, loading: false, scyears: action.payload};

        case SC_VISUALISATION_DETAILS:
            return { ...state, loading: false, scvisualisationdetails: action.payload};  

        case SC_CREATE_VISUALISATION:
            return { ...state, loading: false};    
        
        case SC_VISUALISATION_DELETE:
            return { ...state, loading: false};       
       
        default: return { ...state };
    }
}